// import Vue from 'vue'
import dayjs from "dayjs"
import axios from "axios"

// TODO:
// SDK should be removed from the codebase, long term strategy is to remove it
// We have ti here mostly for demo purposes because aia microsite is using sdk in the code
import { gqlES5, gql } from "@covergo/covergo-sdk"

import {
	required,
	requiredIf,
	email,
	minLength,
	maxLength,
	minValue,
	maxValue,
	alpha,
	alphaNum,
	numeric,
	sameAs,
	helpers as vuelidateHelpers
} from "vuelidate/lib/validators"
import { debounce, get } from "lodash"

import { hkid, minWords, ageBetween, noChinese } from "@/dependencyInjections/vuelidateCustomValidators"

import { t, tFromArray } from "@/dependencyInjections/injectionFunctions"

export default () => {
	return {
		// for creating component level instances
		axios,
		// https://github.com/iamkun/dayjs
		dayjs,
		// Vuelidate Builtin validators -- https://vuelidate.netlify.com/#sub-builtin-validators
		required,
		requiredIf,
		email,
		minLength,
		maxLength,
		minValue,
		maxValue,
		alpha,
		alphaNum,
		numeric,
		vuelidateHelpers, // vuelidate helpers
		// Custom validators - ~/dependencyInjections/vuelidateCustomValidators.js
		hkid,
		minWords,
		ageBetween,
		noChinese,
		// SDK - https://github.com/CoverGo/sdk-js
		gqlES5,
		gql,
		// lodash helpers
		debounce,
		get,
		// localization / translation helpers
		t,
		tFromArray,
		sameAs
	}
}
